import { FC, useCallback, useState } from 'react'
import { Box, Fade, Grid, IconButton, Modal } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

type Props = {
  paths: string[]
}

export const ZoomImageList: FC<Props> = ({ paths }) => {
  const [isOpen, setIsOpen] = useState(false)
  const handleClose = useCallback(() => setIsOpen(false), [])
  const [viewIndex, setViewIndex] = useState(0)
  const handleNext = useCallback(() => {
    setViewIndex((prev) => Math.min(prev + 1, paths.length - 1))
  }, [])
  const handleBack = useCallback(() => {
    setViewIndex((prev) => Math.max(prev - 1, 0))
  }, [])
  const handleClickImage = useCallback(
    (index: number) => () => {
      setIsOpen(true)
      setViewIndex(index)
    },
    [],
  )

  return (
    <>
      <Grid container spacing={1}>
        {paths.map((path, i) => {
          return (
            <Grid key={path} sx={{ height: '150px' }} size={4}>
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */}
              <img
                src={path}
                style={{
                  objectFit: 'cover',
                  display: 'block',
                  width: '100%',
                  height: '100%',
                  cursor: 'zoom-in',
                }}
                alt=""
                onClick={handleClickImage(i)}
              />
            </Grid>
          )
        })}
      </Grid>
      <Modal open={isOpen} onClose={handleClose}>
        <Fade in={isOpen}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              outline: 0,
            }}
          >
            <Box
              sx={{
                width: { sm: '80vw', xs: '95vw' },
                maxWidth: '1200px',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                outline: 0,
              }}
            >
              <img
                src={paths[viewIndex]}
                style={{
                  objectFit: 'cover',
                  display: 'block',
                  width: '100%',
                  height: '100%',
                  borderRadius: '5px',
                }}
                alt=""
                loading="lazy"
              />
              {paths.length > 1 && (
                <>
                  <IconButton
                    sx={{
                      position: 'absolute',
                      light: '0%',
                      top: '50%',
                      transform: 'translate(-150%, -50%)',
                      backgroundColor: 'white',
                      display: viewIndex === 0 ? 'none' : { sm: 'block', xs: 'none' },
                      '&:hover': {
                        backgroundColor: 'white',
                      },
                    }}
                    onClick={handleBack}
                  >
                    <ArrowBackIcon />
                  </IconButton>
                  <IconButton
                    sx={{
                      position: 'absolute',
                      right: '0%',
                      top: '50%',
                      transform: 'translate(150%, -50%)',
                      backgroundColor: 'white',
                      display: viewIndex + 1 === paths.length ? 'none' : undefined,
                      '&:hover': {
                        backgroundColor: 'white',
                      },
                    }}
                    onClick={handleNext}
                  >
                    <ArrowForwardIcon />
                  </IconButton>
                </>
              )}
            </Box>

            {paths.length > 1 && (
              <Box
                sx={{
                  position: 'absolute',
                  bottom: '-48vh',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '300px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 2,
                }}
              >
                {paths.map((path, i) => {
                  return (
                    <Box
                      key={path}
                      sx={{
                        width: '13px',
                        height: '13px',
                        borderRadius: '50%',
                        backgroundColor: viewIndex === i ? 'grey.800' : 'grey.300',
                        cursor: 'pointer',
                      }}
                      onClick={() => setViewIndex(i)}
                    />
                  )
                })}
              </Box>
            )}
          </Box>
        </Fade>
      </Modal>
    </>
  )
}
